import { BsZoomIn } from 'react-icons/bs'

import Empty from '../../components/empty/Empty'

const Gallery = ({galleries, isSetObj, isSetModal}) => {

      if(galleries.data){

            return (
                  <div className="container">
                        <Empty text={`No Photo Available`} />
                  </div>
            )
      }

      const openModal = (item) => {
            isSetObj(item)
            isSetModal(true)
      }

      return (
            <div className="container">
                  <div className="wrapper_gallery">
                        {
                              galleries.map((item, index) => (
                                    <div className="gallery_row" key={index}>
                                          <img src={item.image} alt={item.description} />
                                          <button className="btn_open__modal" onClick={() => openModal(item)}><BsZoomIn /></button>
                                    </div>
                              ))
                        }
                        
                  </div>
            </div>
      )
}

export default Gallery
